<template>
<div class="asd-root" :style="themePageStyle">

  <nav class="asd-topbar"><div class="container d-flex align-items-center justify-content-between py-2">
    <div class="d-flex align-items-center" style="gap:12px;">
      <back-button class="me-2" />
      <a href="javascript:void(0)" @click="$router.push('/dashboard')"><img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
      <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;">Agro Shop</span>
    </div>
    <button class="btn btn-sm btn-outline-warning" @click="$router.push('/shop')"><i class="mdi mdi-storefront-outline me-1"></i>Browse Shop</button>
  </div></nav>

  <div class="container asd-container">
    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

    <!-- Not registered yet -->
    <div v-else-if="!shop" class="text-center py-5" style="max-width:520px;margin:0 auto;">
      <i class="mdi mdi-storefront" style="font-size:64px;color:#BFA164;"></i>
      <h4 class="mt-3 fw-bold" style="color:var(--fm-h,#F5F0E8);">Sell on Flockr's Agro-Input Shop</h4>
      <p style="color:var(--fm-s,#6B6356);font-size:13px;">
        Register your agrovet, feed store or input shop to list feeds, vet drugs, seeds and equipment. Buyers pay via M-Pesa and escrow holds funds until they confirm delivery.
      </p>
      <ul class="asd-perks">
        <li><i class="mdi mdi-check-circle me-2" style="color:#50C878;"></i>Reach farmers across the region</li>
        <li><i class="mdi mdi-check-circle me-2" style="color:#50C878;"></i>Secure M-Pesa payments via escrow</li>
        <li><i class="mdi mdi-check-circle me-2" style="color:#50C878;"></i>Set your own delivery rates</li>
      </ul>
      <button class="btn btn-warning btn-lg mt-2" @click="$router.push('/sell/shop')"><i class="mdi mdi-plus me-1"></i>Register your Agro Shop</button>
    </div>

    <!-- Registered: dashboard -->
    <div v-else>
      <!-- Shop header -->
      <div class="asd-card mb-3">
        <div class="d-flex align-items-center gap-3 flex-wrap">
          <div class="asd-logo" :style="shop.logo_url ? 'background-image:url('+imgUrl(shop.logo_url)+')' : ''">
            <i v-if="!shop.logo_url" class="mdi mdi-storefront" style="font-size:30px;color:var(--fm-s,#6B6356);"></i>
          </div>
          <div class="flex-fill">
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <h5 class="m-0 fw-bold" style="color:var(--fm-h,#F5F0E8);">{{ shop.shop_name }}</h5>
              <span class="asd-kyc" :class="'asd-kyc-'+(shop.kyc_status||'pending')">
                <i class="mdi" :class="shop.kyc_status==='verified'?'mdi-check-decagram':(shop.kyc_status==='rejected'?'mdi-close-octagon':'mdi-clock-outline')"></i>
                {{ humanize(shop.kyc_status||'pending') }}
              </span>
            </div>
            <div style="color:var(--fm-s,#6B6356);font-size:12px;margin-top:3px;text-transform:capitalize;">
              {{ (shop.shop_type||'').replace(/_/g,' ') }}<span v-if="shop.county_name"> · {{ shop.county_name }}</span><span v-if="shop.physical_address"> · {{ shop.physical_address }}</span>
            </div>
          </div>
          <button class="btn btn-sm btn-outline-warning" @click="$router.push('/sell/shop')"><i class="mdi mdi-pencil me-1"></i>Edit shop</button>
        </div>
        <div v-if="(shop.kyc_status||'pending')==='pending'" class="asd-note mt-3"><i class="mdi mdi-clock-outline me-1"></i>Your shop is <strong>awaiting verification</strong> by Flockr. You'll be able to list products once it's verified — we'll review it shortly.</div>
        <div v-else-if="shop.kyc_status==='rejected'" class="asd-note asd-note-danger mt-3"><i class="mdi mdi-alert me-1"></i>Your verification was rejected. Update your shop details and we'll review again before you can list products.</div>
      </div>

      <!-- Stats -->
      <div class="row g-2 mb-3">
        <div class="col-6 col-md-3"><div class="asd-stat"><div class="asd-stat-l">Listed</div><div class="asd-stat-v" style="color:#BFA164;">{{ stats.total || 0 }}</div></div></div>
        <div class="col-6 col-md-3"><div class="asd-stat"><div class="asd-stat-l">Active</div><div class="asd-stat-v" style="color:#50C878;">{{ stats.active || 0 }}</div></div></div>
        <div class="col-6 col-md-3"><div class="asd-stat"><div class="asd-stat-l">Out of stock</div><div class="asd-stat-v" style="color:#FF6B6B;">{{ stats.out_of_stock || 0 }}</div></div></div>
        <div class="col-6 col-md-3"><div class="asd-stat"><div class="asd-stat-l">Total sold</div><div class="asd-stat-v" style="color:#BFA164;">{{ stats.total_sold || 0 }}</div></div></div>
      </div>

      <!-- Quick actions -->
      <div class="row g-2">
        <div class="col-6 col-md-4"><div class="asd-act" :class="{'asd-act-disabled':!verified}" @click="addProduct"><i class="mdi mdi-plus-box" :style="{color:verified?'#50C878':'#6B6356'}"></i><span>Add product<small v-if="!verified" style="display:block;color:var(--fm-s,#6B6356);font-weight:400;">verify shop first</small></span></div></div>
        <div class="col-6 col-md-4"><div class="asd-act" @click="$router.push('/sell/products')"><i class="mdi mdi-package-variant" style="color:#BFA164;"></i><span>Manage products</span></div></div>
        <div class="col-6 col-md-4"><div class="asd-act" @click="$router.push('/sell/delivery')"><i class="mdi mdi-truck-delivery" style="color:#4FC3F7;"></i><span>Delivery rates</span></div></div>
        <div class="col-6 col-md-4"><div class="asd-act" @click="$router.push('/shop')"><i class="mdi mdi-eye-outline" style="color:#CE93D8;"></i><span>View public shop</span></div></div>
        <div class="col-6 col-md-4"><div class="asd-act" @click="$router.push('/orders')"><i class="mdi mdi-receipt-text" style="color:#FF9800;"></i><span>Orders</span></div></div>
        <div class="col-6 col-md-4"><div class="asd-act" @click="$router.push('/sell/shop')"><i class="mdi mdi-storefront-edit" style="color:#A09888;"></i><span>Shop profile</span></div></div>
      </div>
    </div>
  </div>
</div>
</template>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] .asd-root{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .asd-topbar{background:rgba(255,255,255,.95)!important;border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .asd-card,html[data-theme="light"] .asd-stat,html[data-theme="light"] .asd-act{background:#FFFFFF!important;border-color:#E8E2DA!important}
</style>

<style scoped>
.asd-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh;color:var(--fm-h,#F5F0E8)}
.asd-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.asd-container{padding-top:80px;padding-bottom:60px;max-width:1000px}
.asd-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:18px}
.asd-logo{width:64px;height:64px;border-radius:12px;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);background-size:cover;background-position:center;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.asd-kyc{font-size:11px;font-weight:700;padding:3px 10px;border-radius:20px;display:inline-flex;align-items:center;gap:4px}
.asd-kyc-pending{background:rgba(241,180,76,.16);color:#f1b44c}
.asd-kyc-verified{background:rgba(80,200,120,.16);color:#50C878}
.asd-kyc-rejected{background:rgba(255,107,107,.16);color:#FF6B6B}
.asd-note{font-size:11px;color:#f1b44c;background:rgba(241,180,76,.08);border:1px solid rgba(241,180,76,.2);border-radius:8px;padding:8px 10px}
.asd-note-danger{color:#FF6B6B;background:rgba(255,107,107,.08);border-color:rgba(255,107,107,.2)}
.asd-stat{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:10px 12px;text-align:center}
.asd-stat-l{color:var(--fm-s,#6B6356);font-size:10px;text-transform:uppercase;letter-spacing:.4px;font-weight:600}
.asd-stat-v{font-weight:700;font-size:20px;margin-top:2px}
.asd-act{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:18px 12px;display:flex;flex-direction:column;align-items:center;gap:8px;cursor:pointer;transition:border-color .15s}
.asd-act:hover{border-color:#BFA164}
.asd-act-disabled{opacity:.55}
.asd-act-disabled:hover{border-color:var(--fm-br,#1E1E1E)}
.asd-act i{font-size:26px}
.asd-act span{color:var(--fm-h,#F5F0E8);font-size:12px;font-weight:600;text-align:center}
.asd-perks{list-style:none;padding:0;margin:16px auto;max-width:280px;text-align:left}
.asd-perks li{color:var(--fm-m,#A09888);font-size:13px;padding:4px 0}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .asd-container { padding-top: 70px !important; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)) !important; padding-left: 12px !important; padding-right: 12px !important; }
  .asd-card { padding: 12px !important; border-radius: 10px !important; }
  .asd-act { padding: 12px; }
  .asd-act i { font-size: 22px; }
  .asd-act span { font-size: 11px; }
  .asd-perks li { font-size: 12px; }
}
</style>

<script>
/* eslint-disable */
import { executeJson, flocker, uploads } from "@/api";
export default {
  name: "AgroShopDashboard",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null, loading:true, shop:null, stats:{}
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    verified(){return !!(this.shop && this.shop.kyc_status==='verified')}
  },
  mounted(){
    this._applyThemeOnce();
    var self=this;
    this.themeObserver=new MutationObserver(function(){try{self._applyThemeOnce();}catch(e){}});
    this.themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    if(!sessionStorage.getItem('userId')){this.$router.push('/login?redirect=/sell/dashboard');return}
    this.load();
  },
  beforeUnmount(){if(this.themeObserver){this.themeObserver.disconnect();this.themeObserver=null}},
  methods:{
    _applyThemeOnce(){
      var current=document.documentElement.getAttribute('data-theme');
      var desired=(localStorage.getItem('flockr_theme')||current||'dark');
      if(current!==desired) document.documentElement.setAttribute('data-theme',desired);
      this.darkMode=desired!=='light';
    },
    imgUrl(u){if(!u)return'';if(String(u).indexOf('http')===0)return u;return uploads+String(u).replace(/^uploads\//,'');},
    addProduct(){ if(!this.verified){ alert('Your shop must be verified by Flockr before you can list products. You\'ll be notified once verification is complete.'); return; } this.$router.push('/sell/product/create'); },
    humanize(s){return (s||'').replace(/_/g,' ').replace(/\b\w/g,function(c){return c.toUpperCase()})},
    async load(){
      this.loading=true;
      try{
        var r=await executeJson({function:'getMyAgroShop',ownerId:sessionStorage.getItem('userId')},flocker);
        this.shop=(r.data&&r.data.success&&r.data.data&&r.data.data.shop)||null;
        if(this.shop){
          var p=await executeJson({function:'getMyProducts',sellerId:sessionStorage.getItem('userId')},flocker);
          if(p.data&&p.data.success)this.stats=(p.data.data&&p.data.data.stats)||{};
        }
      }catch(e){console.error(e)}
      this.loading=false;
    }
  }
};
</script>
